import React, { useState } from "react"
import { Row, Col } from 'antd'
import { useWindowSize } from '@react-hook/window-size'
import moment from 'moment'

import BumpChart from '../charts/BumpChart/BumpChartComponent'
import BumpChartVertical from '../charts/BumpChartVertical/BumpChartComponent'
import Section from '../Sections/Section'
import themeEvolution from '../../assets/data/themeEvolution.json'
import './TweetThemes.css'

function TweetThemesGlobal() {
  const [width, height] = useWindowSize();
  //const [normalize, setNormalize] = useState(null)
  const [sectionsProgress, setSectionsProgress] = useState({});
  const [highlight, setHighlight] = useState({});

  const setSectionProgress = (id, progress) => {
    sectionsProgress[id] =  { progress };
    setSectionsProgress({...sectionsProgress});
    if(sectionsProgress['sectionA'] && sectionsProgress['sectionA'].progress > 0 && sectionsProgress['sectionA'].progress < 1) {
      setHighlight({ items: [themeEvolution.keys[Math.floor(themeEvolution.keys.length * sectionsProgress['sectionA'].progress)]], dates: null})
    } else if(sectionsProgress['sectionB'] && sectionsProgress['sectionB'].progress > 0 && sectionsProgress['sectionB'].progress < 1) {
      setHighlight({ items: ['écologie'], dates: [moment('2018-04-01'), moment('2019-04-01')]})
    } else if(sectionsProgress['sectionC'] && sectionsProgress['sectionC'].progress > 0 && sectionsProgress['sectionC'].progress < 1) {
      setHighlight({ items: null, dates: [moment('2018-12-01'), moment('2019-05-01')]})
    } else if(sectionsProgress['sectionD'] && sectionsProgress['sectionD'].progress > 0 && sectionsProgress['sectionD'].progress < 1) {
      setHighlight({ items: ['coronavirus', 'santé'], dates: [moment('2020-01-01'), moment('2021-01-01')]})
    } else {
      setHighlight(null)
    }
  }

  return (
    <div style={{ marginBottom: 40 }}>
      { width < 900 &&
        <div style={{ padding: width >= 900 ? 0 : 16 }}>
          <h1>What are they talking about ?</h1>
          <p>What are the major themes covered by the political leaders? What do they want journalists (very present on Twitter) and citizens to take away from their speeches?</p>
        </div>
      }
      <div className="graphic" >
        { width >= 900 &&
          <div style={{ padding: width >= 900 ? 0 : 16 }}>
            <h1>What are they talking about ?</h1>
            <p>What are the major themes covered by the political leaders? What do they want journalists (very present on Twitter) and citizens to take away from their speeches?</p>
          </div>
        }
        {/*<Row type="flex" justify="end">
          <div>{normalize ? 'Vue relative' : 'Vue absolue'} <Switch checked={normalize} onChange={setNormalize} /></div>
          </Row>*/}
        { width >= 900 &&
          <BumpChart 
            data={{ 
              ...themeEvolution, 
              values: themeEvolution.values
                .filter(d => moment(d.date).isSameOrAfter('2018-01-01'))
            }} 
            //normalize={normalize}
            height={height * 0.85} 
            highlight={highlight}
          />
        }
        { width < 900 &&
          <BumpChartVertical 
            data={{ 
              ...themeEvolution, 
              values: themeEvolution.values
                .filter(d => moment(d.date).isSameOrAfter('2018-01-01'))
            }} 
            //normalize={normalize}
            height={height* 0.83} 
            highlight={highlight}
          />
        }
      </div>
      <Row type="flex" justify="space-between">
        <Col span={width < 900 ? 20 : 12} offset={width < 900 ? 2 : 6}>
          <div style={{ zIndex: 1000, position: 'relative' }}>
            <Section id='sectionA' setSectionProgress={setSectionProgress} >
              <h3>The main themes</h3>
              <p>This graph shows the evolution of the topics discussed over the months. Each colored band is associated with a theme. The thickness of the strip represents the number of tweets. The position indicates the order of importance of the themes during the period. We see, for example, that politics is almost always the most common theme.</p>
            </Section>
            <Section id='sectionB' setSectionProgress={setSectionProgress} >
              <p><strong>Ecology.</strong> During the 2018 and 2019 campaigns, the issue of ecology stirred the debates. The theme is promising: on January 27, 2019, <a target = "_ blank" rel = "noopener noreferrer" href = "https://www.rtbf.be/info/societe/detail_des-dizaines-de-milliers-de- people-expected-again-in-brussels-for-the-climate? id = 10129506 "> 70,000 people take part in a march for the climate in Brussels </a>. In April, <a target = "_ blank" rel = "noopener noreferrer" href = "https://www.rtbf.be/info/belgique/detail_barometre-politique-d-ou-vient-la-vague-verte-ecolo -can-he-still-do-better? id = 10203538 "> poll predicts increased votes for environmentalists </a>. We find this “green wave” in the tweets.</p>            
            </Section>
            <Section id='sectionC' setSectionProgress={setSectionProgress} style={{ marginBottom: '50vh' }} >
              <p><strong> Employment and Pension. </strong> During the 2019 election campaign, political leaders were particularly present on Twitter, and the number of tweets exploded. During this period, the economic subjects took a considerable dimension in the debates. Retirement age, savings of Belgians, tax shift ... to attract voters, each party <a target = "_ blank" rel = "noopener noreferrer" href = "https://www.rtbf.be/info / belgique / detail_elections-federales-2019-the-flagship-measures-of-the-parties-and-what-they-should-cost-according to the-bureau-du-plan? id = 10205362 "> made their own proposals </a>.</p>
            </Section>
            <Section id='sectionD' setSectionProgress={setSectionProgress} style={{ marginBottom: '50vh' }} >
              <p><strong> Health. </strong> Long put aside, the issue of health care became the top concern in the month of February 2020. In the midst of the Covid-19 pandemic, when an unprecedented confinement is set up, the sector denounces a lack of means.</p>
            </Section>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default TweetThemesGlobal;
